import React from 'react';
import { INSTANCE_HOME, isNavItemActive } from './adminNav';
import RunStrip from './RunStrip';
import StageSwitcher from './StageSwitcher';
import NavMenu from './NavMenu';
import { LiveChip, NextStep } from './StageRowStatus';
import { NarrowOnly, DrawerHeading, DrawerLink } from './AdminHeader.styles';
import { StageRow, StageTabs, StageTab, RowDivider } from './InstanceNav.styles';

/**
 * InstanceNav - the stage row under the admin top bar, on instance pages:
 * the active stage's tabs. Below TOP_STAGES_MIN the row starts with the stage
 * selector (wider, it is in the top bar) and a hamburger menu of the stage's
 * pages, and the tabs show only their icons. The row ends in the run strip
 * on Toteutus pages (participant PIN, lock); elsewhere in a live chip while
 * the workshop runs, else — for admins — the next step. `stageNav` comes from
 * useStageNav, shared with the top bar.
 */
const InstanceNav = ({ instanceId, stages, showHome, pathname, buildPath, stageNav }) => {
  const { activeStage, instanceStage, chain, live, justLeftLive, navTo } = stageNav;

  return (
    <StageRow aria-label="Vaiheen sivut">
      <NarrowOnly>
        <StageSwitcher
          stages={stages}
          showHome={showHome}
          pathname={pathname}
          activeStage={activeStage}
          instanceStage={instanceStage}
          buildPath={buildPath}
          navTo={navTo}
        />
        {activeStage && (
          <>
            <NavMenu label={`${activeStage.label}: sivut`} compact>
              <DrawerHeading>{activeStage.label}</DrawerHeading>
              {activeStage.items.map((item) => {
                const Icon = item.icon;
                return (
                  <DrawerLink
                    key={item.key}
                    $active={isNavItemActive(item, pathname)}
                    onClick={() => navTo(buildPath(item.path))}
                  >
                    <Icon size={18} />
                    {item.label}
                  </DrawerLink>
                );
              })}
            </NavMenu>
            <RowDivider aria-hidden="true" />
          </>
        )}
      </NarrowOnly>

      {activeStage && (
        <>
          <StageTabs>
            {activeStage.items.map((item) => {
              const Icon = item.icon;
              return (
                <StageTab
                  key={item.key}
                  type="button"
                  $active={isNavItemActive(item, pathname)}
                  title={item.label}
                  onClick={() => navTo(buildPath(item.path))}
                >
                  <Icon size={15} />
                  <span className="label">{item.label}</span>
                </StageTab>
              );
            })}
          </StageTabs>
        </>
      )}

      {activeStage?.key === 'run' && <RunStrip instanceId={instanceId} />}
      {activeStage?.key !== 'run' && live && (
        <LiveChip chain={chain} justLeft={justLeftLive} onNavigate={navTo} buildPath={buildPath} />
      )}
      {activeStage?.key !== 'run' && !live && showHome && pathname !== INSTANCE_HOME.path && (
        <NextStep instanceId={instanceId} chain={chain} onNavigate={navTo} buildPath={buildPath} />
      )}
    </StageRow>
  );
};

export default InstanceNav;
